export const openDocument = (windowReference, data) => {
  const file = new Blob([data], { type: 'application/pdf' });
  const fileUrl = window.URL.createObjectURL(file);

  // eslint-disable-next-line no-param-reassign
  windowReference.location = `${process.env.PUBLIC_URL || ''}/pdfjs/web/viewer.html?file=${encodeURIComponent(fileUrl)}`;
};
